// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn[data-v-41021a8d] {\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  border-radius: 10px;\r\n  font-weight: 400;\n}\r\n", ""]);
// Exports
module.exports = exports;
